var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"hero is-primary is-fullheight-with-navbar"},[_c('div',{staticClass:"hero-body"},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"title"},[_vm._v("Ops!")]),_c('h2',{staticClass:"subtitle"},[_vm._v("Non dovresti essere qui.")])])])])
}]

export { render, staticRenderFns }